import { styled, TextField, TextFieldProps } from '@mui/material';

export const Input = styled(TextField)<TextFieldProps>(({ theme, size }) => ({
  boxSizing: 'border-box',
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius,

  '& .MuiInputBase-root ': {
    height: 42,
    paddingRight: '10px',
  },
  '& .MuiInputBase-input': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '& .MuiFormHelperText-root': {
    height: 0,
  },
  ...(size === 'small' && {
    '& .MuiInputBase-root ': {
      padding: '4px 0 5px',
    },
    input: { height: '100%', minHeight: 24, padding: 0 },
  }),
}));
